import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useOrgPreset } from '@/hooks/shared/useOrgPreset';
import { isRouteAllowedByPreset } from '@/lib/orgPresets';

/**
 * Fecha o ambiente de uma org com preset de interface: rota fora da lista do preset
 * redireciona para a home dele. Esconder só o item do menu deixaria a URL aberta.
 *
 * Sem preset, ou com preset só de marca (`shell: null`), é um repasse puro. O console
 * Super-Admin e a Supervisão vivem fora do AppLayout e não passam por aqui.
 */
export const OrgPresetRouteGuard: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const preset = useOrgPreset();
  const { pathname } = useLocation();

  if (preset?.shell && !isRouteAllowedByPreset(preset, pathname)) {
    return <Navigate to={preset.shell.homeRoute} replace />;
  }
  return <>{children}</>;
};
